import { render, staticRenderFns } from "./ResetPasswordModal.vue?vue&type=template&id=257cf2bc&"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports